import { useAuth0 } from "@auth0/auth0-react";
import styles from "./accountlistcard.module.css";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { Area, AreaChart, ResponsiveContainer, Tooltip } from "recharts";
import axios from "axios";

const PartialVerticalCursor = (props) => {
    const { points, stroke, chartHeight } = props;
    if (!points || !points.length) return null;
    const { x, y } = points[0];

    return (<line x1={x} y1={y} x2={x} y2={chartHeight} stroke={stroke || "#502688"} strokeWidth={2} />);
};

const CustomActiveDot = (props) => {
    const { cx, cy, stroke, payload } = props;

    return (payload?.daily_request ? <g>
        <line x1={cx} y1={cy} x2={cx} y2={183} stroke={"#502688"} strokeWidth={1} />
        <circle cx={cx} cy={cy} r={5} fill="#502688" stroke={stroke} strokeWidth={1} />
    </g> : null);
}

const APIGraph = ({ item }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [finalData, setFinalData] = useState(null);
    const [total, setTotal] = useState(450);
    const [logsData, setLogsData] = useState([]);
    const [type, setType] = useState("7-days");

    useEffect(() => {
        const getLogs = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/device-logs/" + item?.id + "/" + type, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setLogsData(response.data.data?.data);
                setTotal(response.data.data?.total);
            }).catch(err => { });
        };
        getLogs();
    }, [getAccessTokenSilently, item?.id, type]);


    return (<div className={`${styles.ProspectCardFootSec}`}>
        <p className={`${styles.APISecTitle}`}><img src="/static/img/api-img.svg" alt="" />API Requests</p>
        <div className={`${styles.FOFilterSec}`}>
            {finalData ? <p className={`${styles.FilterText}`}>{finalData?.label}</p> : <div className={`${styles.SelectFilterForFO} FormGroup WithOurBorder`}>
                <FormControl fullWidth>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={type}
                        onChange={(e) => {
                            setType(e.target.value);
                        }}
                    >
                        <MenuItem value={'7-days'}>Last 7 days</MenuItem>
                        <MenuItem value={'30-days'}>Last 30 days</MenuItem>
                        <MenuItem value={'90-days'}>Last 90 days</MenuItem>
                        <MenuItem value={'month-to-date'}>Month to date</MenuItem>
                        <MenuItem value={'year-to-date'}>Year to date</MenuItem>
                    </Select>
                </FormControl>
            </div>}
            <div className={`${styles.FOUpDownSec}`}>
                <div>Total Request <span>{finalData ? finalData?.daily_request : total}</span></div>
            </div>
        </div>
        <ResponsiveContainer width="100%" height={100} className={`${styles.ChartSec}`}>
            <AreaChart
                width={500}
                height={220}
                data={logsData}
                syncId={"Chart" + item?.id}
                margin={{
                    top: 2,
                    right: 0,
                    left: 0,
                    bottom: 0,
                }}
            >
                <defs>
                    <linearGradient id="myGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#502688" stopOpacity={0.7} />
                        <stop offset="100%" stopColor="#502688" stopOpacity={0.1} />
                    </linearGradient>
                </defs>
                <Tooltip
                    cursor={<PartialVerticalCursor />}
                    content={({ active, payload, label }) => {
                        if (active && payload && payload.length) {
                            if (payload[0].payload) {
                                setFinalData(payload[0].payload);
                            } else {
                                setFinalData(null);
                            }
                        } else {
                            setFinalData(null);
                        }
                        return null;
                    }}
                />
                <Area type="monotone" dataKey="daily_request" stroke="#502688" fill="url(#myGradient)" activeDot={<CustomActiveDot />} />
            </AreaChart>
        </ResponsiveContainer>
    </div>)
}


export default APIGraph;